import { McpServer } from '@modelcontextprotocol/sdk/server/mcp.js';
import { StdioServerTransport } from '@modelcontextprotocol/sdk/server/stdio.js';
import config from '../../config';
import { wrapRegister } from './tool-definition';
import tools from './tools';

const server = new McpServer({
  name: config.mcp.serverName,
  version: config.mcp.version,
});

const wrappedRegister = wrapRegister(server);
Object.values(tools).forEach((tool) => {
  tool.setup(wrappedRegister);
});

const start = async () => {
  const transport = new StdioServerTransport();
  await server.connect(transport);
};

export default { start };
